module.exports = __webpack_public_path__ + "img/type-manage.c269829f.svg";